import Layout from '@/hrmLayout'
import mainLayout from '@/layout'
const hrmRouters = [
  {
    path: '/hrm',
    component: Layout,
    meta: {
      title: '绩效考核配置',
      icon: 'settings-4-fill',
      alwaysShow: true,
    },
    redirect: '/hrm/manage_indicator',
    children: [
      {
        path: 'manage_indicator',
        name: 'hrm_manage_indicator',
        component: () => import('@/views/hrm/manageIndicator/index'),
        meta: {
          title: '指标管理',
          icon: 'bar-chart-2-line',
        },
      },
      {
        path: 'manage_performance_template',
        name: 'hrm_manage_performance_template',
        component: () => import('@/views/hrm/manageTemplate/index'),
        meta: {
          title: '模板管理',
          icon: 'file-3-fill',
        },
      },
    ],
  },
  {
    path: '/hrm/manage_evaluation',
    component: Layout,
    children: [
      {
        path: 'index',
        alias: '/hrm/manage_evaluation',
        name: 'hrm_manage_evaluation',
        component: () => import('@/views/hrm/manageEvaluation/index'),
        meta: {
          title: '人才评分配置',
          icon: 'user-add-fill',
        },
      },
    ],
  },
  {
    path: '/hrm/manage_member',
    component: Layout,
    children: [
      {
        path: 'index',
        alias: '/hrm/manage_member',
        name: 'hrm_manage_member',
        component: () => import('@/views/hrm/manageMember/index'),
        meta: {
          title: '人员配置',
          icon: 'user-settings-fill',
        },
      },
    ],
  },
  {
    path: '/hrm/examine',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'hrm_examine',
        // href: 'http://' + window.location.host + '/hrm/manage_examine',
        redirect: '/hrm/manage_examine',
        meta: {
          title: '绩效考核',
          icon: 'checkbox-circle-line',
          // target: '_blank',
        },
      },
    ],
  },
  {
    path: '/hrm/examine_improve_manage',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'hrm_examine_improve_manage',
        alias: '/hrm/examine_improve_manage',
        component: () => import('@/views/hrm/examineImprovePlan/index'),
        meta: {
          title: '绩效改进计划',
          icon: 'file-list-3-line',
        },
      },
    ],
  },
  {
    path: '/hrm/manage_archive_examine',
    component: Layout,
    children: [
      {
        path: 'index',
        alias: '/hrm/manage_archive_examine',
        name: 'hrm_manage_archive_examine',
        component: () => import('@/views/hrm/manageArchiveExamine/index'),
        meta: {
          title: '审核归档',
          icon: 'inbox-archive-fill',
        },
      },
    ],
  },
]

const examineRoute = {
  path: '/hrm/manage_examine',
  name: 'hrm_manage_examine',
  hidden: true,
  component: () => import('@/views/hrm/manageExamine/index'),
  meta: {
    title: '绩效考核',
  },
}

const examineImproveRoute = {
  path: '/hrm/examine_improve',
  name: 'hrm_examine_improve',
  hidden: true,
  component: () => import('@/views/hrm/examineImprovePlan/index'),
  meta: {
    title: '绩效改进计划',
  },
}
const dutyPlanRoute = {
  path: 'hrm',
  component: mainLayout,
  children: [
    {
      path: 'duty_plan',
      name: 'dutyPlan',
      hidden: false,
      component: () => import('@/views/hrm/manageExamine/components/dutyPlan'),
      meta: {
        title: '排班表',
        icon: 'calendar-event-fill',
      },
    },
  ],
}

export { hrmRouters, examineRoute, examineImproveRoute, dutyPlanRoute }
